import request from '@/utils/request'

export function getResNoList(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa220/getResNoList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epmsa220Show(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa220/epmsa220Show`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epmsa220Add(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa220/epmsa220Add`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epmsa220LotNo(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa220/epmsa220LotNo`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epmsa220CutGrp(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa220/epmsa220CutGrp`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epmsa220save(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa220/epmsa220save`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epmsa220AddReq(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa220/epmsa220AddReq`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

//epmsa220delete
export function epmsa220delete(param) {
  let data = param
  return request({
    url: `/outsoucingBlockControl/epmsa220/epmsa220delete`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}


